<template>
    <div class="instagram-interface" ref="instagramInterface">
        <div class="page-name">
            <p>{{ page ? page.name : 'Instagram' }}</p>
        </div>
        <div class="user-info">
            <div class="picture">
                <img :src="page && page.avatar ? page.avatar : 'img/avatar.jpg'">
            </div>
            <div class="stats">
                <div class="stat">
                    <p>{{ statsProfile.media_count }}</p>
                    <label>Publications</label>
                </div>
                <div class="stat">
                    <p>{{ statsProfile.followers_count }}</p>
                    <label>Followers</label>
                </div>
                <div class="stat">
                    <p>{{ statsProfile.follows_count }}</p>
                    <label>Suivi(e)s</label>
                </div>
            </div>
        </div>
        <div class="nav">
            <div class="item">
                <svg fill="currentColor" height="100%" width="100%" viewBox="0 0 24 24" ><rect fill="none" height="18" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" width="18" x="3" y="3"></rect><line fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" x1="9.015" x2="9.015" y1="3" y2="21"></line><line fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" x1="14.985" x2="14.985" y1="3" y2="21"></line><line fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" x1="21" x2="3" y1="9.015" y2="9.015"></line><line fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" x1="21" x2="3" y1="14.985" y2="14.985"></line></svg>
            </div>
        </div>
        <div class="container-grid hide-scrollbar" @scroll="handleScroll" ref="scrollContainer">
            <draggable 
                class="list-photo hide-scrollbar" 
                ref="listMedia" 
                v-model="list" 
                v-bind="dragOptions" 
                :move="checkMove"
                :filter="'.posted'"
                @start="drag=true" 
                @end="drag=false"   
                @update="updateList"
                >
                <transition-group type="transition" :name="'flip-list'">
          
                    <div 
                      
                        class="photo" 
                        :class="[post.status, post.type]"
                        v-for="post in list" :key="post.id"
                        :style="{ backgroundImage: `url(${post.url})` }"
                        :id="post.id"
                    >

                        <div class="circle-status card-status-background-primary-color" :class=[post.status]></div>
                    </div>

                    <div 
                        v-if="loadingCard"
                        class="photo loading" 
                        v-for="(test, index) in Array.from({length: this.list.length % 3 + 6})"
                        :key="index"
                        :style="`animation-delay: ${index * 0.2}s`"
                        >
                    </div>
  
                </transition-group>
            </draggable>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable'
    export default {
        components: {
            draggable
        },
        props: {
            plannedItems: Array,
            postedItems: Array,
            pinnedItems: Array,
            page: Object,
            statsProfile:Object,
            loadingCard:Boolean
        },
        
        data() {
            return {
                list: [],
            };
        },

        mounted () {

        },

        methods: {
            updateList(e) {
                console.log("updateList",e)
                this.$nextTick(()=>{
                    const postId =  e.item.id
                    const msInterval = 5 * 60 * 1000 //5minutes

                    let itemIndex = -1 
                    let newDate

                    const posts = this.list.filter(item => !['posted'].includes(item.status))

                    itemIndex = posts.findIndex(post => post.id == postId)
                
                    if (itemIndex >= 0) {
                        console.log('find',itemIndex)
                        
                        if (itemIndex == 0 && posts[1]) {
                            //retire 5minutes par rapport a l'avant derniere date
                            console.log("first", posts[1].date)
                            newDate = new Date(new Date(posts[1].date).getTime() + msInterval).toISOString()
                            posts[itemIndex].date = newDate
                        }

                        else if (itemIndex == posts.length - 1 && posts[itemIndex-1]) {
                            console.log("last", posts[itemIndex-1].date)
                            //ajouter 5minutes par rapport a la derniere date
                            newDate = new Date((new Date(posts[itemIndex-1].date)).getTime() - msInterval).toISOString()
                            posts[itemIndex].date = newDate
    
                        }else {
                            const datePostBefore = new Date(posts[itemIndex+1].date).getTime() 
                            const datePostAfter = new Date(posts[itemIndex-1].date).getTime()
                            if (e.newIndex > e.oldIndex) {
                                //ajoute 5minutes par rapport a la date d'avant
                                console.log("ajoute 5minutes par rapport a la date plus future")
                                newDate = datePostAfter - msInterval
                                
                                if (newDate <= datePostBefore) {
                                    newDate = (datePostAfter - datePostBefore) / 2 + datePostBefore
                                }

                                newDate = new Date(newDate).toISOString()
                                posts[itemIndex].date = newDate
                            }else{
                                //ajoute 5minutes par rapport a la date d'apres
                                console.log("ajoute 5minutes par rapport a la date plus proche",newDate,datePostAfter)
                                newDate = datePostBefore + msInterval
                            
                                if (newDate >= datePostAfter) {
                                    newDate = (datePostAfter - datePostBefore) / 2 + datePostBefore
                                }

                                newDate = new Date(newDate).toISOString()
                                posts[itemIndex].date = newDate
                            }
                        }
                    }
                  
                
     

                    if (itemIndex >= 0 && newDate) {
                        this.list = [...this.pinnedItems, ...posts, ...this.postedItems]
       
                        this.$emit('changeDate', {
                            postId,
                            newDate,
                            itemsSort: posts,
                            refreshGroupedItems: true
                        })
                
                    }
                })
            },
            isDisabled(item, index) {
                return index === 0 || index === this.items.length - 1; // Désactive le premier et dernier élément
            },
            checkMove(event) {
                // Empêche le déplacement du premier et dernier élément
                if (this.list[event.relatedContext.index].status == 'posted') {
                    return false;
                }
                return true;
            },

            handleScroll() {
                const container = this.$refs.scrollContainer;
                if (container.clientWidth * 0.41 >= container.scrollHeight - (container.clientHeight + container.scrollTop)) {
                   this.$emit('loadMorePostedItems')
                }
            },
        },

        computed: {
            dragOptions() {
                return {
                    animation: 200,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost"
                };
            },
        },
        watch: {
            plannedItems: {
                immediate: true,
                deep: true,
                handler(newValue, oldValue) {
                this.list = [...this.pinnedItems, ...this.plannedItems, ...this.postedItems]
                }
            },

            postedItems: {
                immediate: true,
                deep: true,
                handler(newValue, oldValue) {
                    console.log("okok")
                    this.list = [...this.pinnedItems, ...this.plannedItems, ...this.postedItems]
                }
            },
        },

        beforeDestroy () {
  
        }
    }
</script>
